module.exports = __webpack_public_path__ + "static/media/all-licenses-used.23ef8558.svg";